/**
 * A caixa de busca do padrão (DESIGN.md, "Busca"): a mesma em todas as telas. A lupa, o campo e, com
 * algo escrito, o × que limpa; Esc também limpa. `onSubmit` faz do Enter uma busca (o Início leva ao
 * Explorar).
 */
import { useT } from '../i18n/index.js';
import { Icon } from './icons.js';

export function SearchBox({
  value,
  onChange,
  placeholder,
  label,
  onSubmit,
  onFocus,
  className,
}: {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  label?: string;
  onSubmit?: (value: string) => void;
  onFocus?: () => void;
  className?: string;
}) {
  const t = useT();
  return (
    <label className={`rd-searchBox${className ? ` ${className}` : ''}`}>
      <Icon name="search" size={16} />
      <input
        type="search"
        value={value}
        placeholder={placeholder}
        aria-label={label ?? placeholder}
        onChange={(e) => onChange(e.target.value)}
        onFocus={onFocus}
        onKeyDown={(e) => {
          if (e.key === 'Escape' && value) onChange('');
          if (e.key === 'Enter' && onSubmit) {
            e.preventDefault();
            onSubmit(value);
          }
        }}
      />
      {value ? (
        <button type="button" className="rd-iconBtn" aria-label={t('common.search.clear')} onClick={() => onChange('')}>
          <Icon name="close" size={14} />
        </button>
      ) : null}
    </label>
  );
}
